import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
// reactstrap components
import { ModalBody, Modal, ModalHeader } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import SurveyContainer from "./SurveyContainer";

const SurveyModalForm: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { showSurveyModal, setIsModalOpen, surveyModalTitle } =
    rootStore.surveyStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["surveys"], translationHookOptions);

  return (
    <>
      <Modal
        isOpen={showSurveyModal}
        toggle={() => setIsModalOpen(!showSurveyModal)}
        className="surveyModal"
      >
        <ModalHeader
          className={classNames(
            "surveyModalHeader",
            theme!.headerColor,
            theme!.headerTextColor
          )}
          toggle={() => setIsModalOpen(!showSurveyModal)}
          close={
            <button
              className="closeModalIcon"
              onClick={() => setIsModalOpen(!showSurveyModal)}
            >
              <i className="far fa-times-circle fa-lg"></i>
            </button>
          }
        >
          {t("surveys_modal_title")} {surveyModalTitle}
        </ModalHeader>
        <ModalBody className="customModal ">
          <SurveyContainer />
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(SurveyModalForm);
